import classnames from 'classnames';
import { startOfWeekLocale } from 'components/DateRangePicker/mondayBasedLocales';
import Month from 'components/Month';
import PlusIcon from 'components/icons/PlusIcon';
import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import differenceInMonths from 'date-fns/differenceInMonths';
import React, { PureComponent } from 'react';
import formatDate from 'utils/formatDate';

import './DateRangePicker.module.scss';

const CSS = require('./DateRangePicker.module.scss');

interface DateRangePickerProps {
  startDate: Date;
  selectedTo: Date | null;
  selectedFrom: Date | null;
  onSelectDay: (m: Date) => void;
  availableDays?: string[];
  className?: string;
  nowFilterEnabled?: boolean;
  onClickNow?: (() => void) | null;
  onClickToday?: () => void;
  onClickTomorrow?: () => void;
}

interface DateRangePickerState {
  amountOfMonths: number;
}

class DateRangePicker extends PureComponent<
  DateRangePickerProps,
  DateRangePickerState
> {
  state = {
    amountOfMonths: 4,
  };

  dateScroller;

  onLoadMoreMonths = () => {
    this.setState({
      amountOfMonths: this.state.amountOfMonths + 2,
    });
  };

  onSelectDay = (date) => {
    this.props.onSelectDay(date);
  };

  componentDidMount() {
    const monthsBetween = differenceInMonths(
      (this.props.selectedFrom as Date) || this.props.startDate,
      this.props.startDate,
    );
    if (this.dateScroller && monthsBetween > 0) {
      const monthBlockHeight = 248;
      this.dateScroller.scrollTop = monthsBetween * monthBlockHeight;
    }
  }

  renderDays() {
    const startOfWeekDay = startOfWeekLocale(new Date());

    return (
      <div className={CSS['DateRangePicker-days']}>
        <span className={CSS['DateRangePicker-days-day']}>
          {(formatDate(startOfWeekDay, 'EE') ?? '').slice(0, 1)}
        </span>
        <span className={CSS['DateRangePicker-days-day']}>
          {(formatDate(addDays(startOfWeekDay, 1), 'EE') ?? '').slice(0, 1)}
        </span>
        <span className={CSS['DateRangePicker-days-day']}>
          {(formatDate(addDays(startOfWeekDay, 2), 'EE') ?? '').slice(0, 1)}
        </span>
        <span className={CSS['DateRangePicker-days-day']}>
          {(formatDate(addDays(startOfWeekDay, 3), 'EE') ?? '').slice(0, 1)}
        </span>
        <span className={CSS['DateRangePicker-days-day']}>
          {(formatDate(addDays(startOfWeekDay, 4), 'EE') ?? '').slice(0, 1)}
        </span>
        <span className={CSS['DateRangePicker-days-day']}>
          {(formatDate(addDays(startOfWeekDay, 5), 'EE') ?? '').slice(0, 1)}
        </span>
        <span className={CSS['DateRangePicker-days-day']}>
          {(formatDate(addDays(startOfWeekDay, 6), 'EE') ?? '').slice(0, 1)}
        </span>
      </div>
    );
  }

  private convertToMap(dates?: string[]): Map<string, boolean> | undefined {
    if (!dates) {
      return undefined;
    }
    const m = new Map<string, boolean>();
    dates.forEach((d) => m.set(d, true));
    return m;
  }

  renderMonths() {
    return Array(this.state.amountOfMonths)
      .fill(null, 0, this.state.amountOfMonths)
      .map((_, index) => {
        const month = addMonths(this.props.startDate, index);
        return (
          <Month
            className={CSS.DateRangePickerMonth}
            key={formatDate(month, 'yyyy-MM')}
            month={month}
            onSelect={this.onSelectDay}
            startDate={this.props.selectedFrom as Date}
            endDate={this.props.selectedTo as Date}
            availableDays={this.convertToMap(this.props.availableDays)}
          />
        );
      });
  }

  setRef = (c) => (this.dateScroller = c);

  renderMore() {
    return (
      <div className={CSS['DateRangePicker-moreButtonContainer']}>
        <button
          className={CSS['DateRangePicker-moreButton']}
          onClick={this.onLoadMoreMonths}
        >
          <PlusIcon
            className={CSS['DateRangePicker-moreButton-icon']}
            color="white"
            width={16}
            height={16}
          />
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className={classnames(this.props.className, CSS.DateRangePicker)}>
        {this.renderDays()}
        <div className={CSS['DateRangePicker-scroller']} ref={this.setRef}>
          {this.renderMonths()}
          {this.renderMore()}
        </div>
      </div>
    );
  }
}

export default DateRangePicker;
